import Accordion from 'antd-mobile/lib/accordion';
export default Accordion;



// WEBPACK FOOTER //
// ./components/accordion/index.tsx